import React, { createContext, useState, useEffect, useContext } from 'react';

const OtpContext = createContext(null);

export const OtpProvider = ({ children }) => {
  const generateOtp = () => Math.floor(100000 + Math.random() * 900000).toString();

  const [otp, setOtp] = useState(generateOtp());
  const [expiresAt, setExpiresAt] = useState(Date.now() + 15000);

  useEffect(() => {
    const interval = setInterval(() => {
      setOtp(generateOtp());
      setExpiresAt(Date.now() + 15000);
    }, 15000);

    return () => clearInterval(interval);
  }, []);

  return (
    <OtpContext.Provider value={{ otp, expiresAt }}>
      {children}
    </OtpContext.Provider>
  );
};

export const useOtp = () => useContext(OtpContext);

